export const NotFoundPic = ({ className }: { className?: string }) => {
  return (
    <svg width="100" height="100" fill="none" className={className}>
      <circle cx="50" cy="50" r="50" fill="#DCE6F9" fillOpacity=".6" />
      <path d="M49.889 45.378v34.345L23.223 68.205l.127-34.22 26.539 11.393Z" fill="#418DF9" />
      <path d="M49.889 45.398v34.345l26.536-11.12v-34.53L49.889 45.399Z" fill="#A2BDFF" />
      <path d="m49.889 45.378 26.666-11.169-26.457-11.727L23.223 33.93l26.666 11.448Z" fill="#0E84E5" />
      <path
        d="m15.94 40.056 26.836 13.026a.366.366 0 0 0 .435-.088l6.678-7.616L23.221 33.93l-7.341 5.505a.366.366 0 0 0 .06.621ZM76.555 34.209l7.405 6.695a.367.367 0 0 1-.096.606L57.36 53.34a.366.366 0 0 1-.421-.09l-7.05-7.872 26.667-11.17ZM50.098 22.482l26.53 11.727 3.816-.884a.366.366 0 0 0 .063-.693L56.28 22.136a.367.367 0 0 0-.168-.029l-6.015.376ZM50.098 22.482 23.716 33.983l-3.335-.56a.365.365 0 0 1-.077-.696L45.13 22.029a.367.367 0 0 1 .174-.028l4.795.48Z"
        fill="#699CFF"
      />
      <path
        d="M58.867 60.165c-.044-1.084-.452-1.948-.912-1.93-.46.02-.797.913-.753 1.998.044 1.084.452 1.948.912 1.93.46-.02.797-.914.753-1.998ZM71.374 57.336c-.028-1.085-.424-1.955-.884-1.943-.46.012-.81.9-.783 1.986.028 1.085.424 1.954.884 1.942.46-.011.81-.9.783-1.985ZM67.23 63.962a.283.283 0 0 1-.35-.06c-.156-.174-.682-.654-1.042-.568-.36.087-.778.769-.924 1.085a.283.283 0 0 1-.514-.237c.057-.125.584-1.225 1.306-1.398.752-.18 1.513.648 1.597.743a.283.283 0 0 1-.073.435Z"
        fill="#fff"
      />
    </svg>
  );
};
